import { apiSlice, asyncToastDisplay, i18n} from "./apiSlice";

export const publisherUserApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPublisherUsers: builder.query({
      query: (publisherId) => (`/publishers/${publisherId}/users`),
      providesTags: (result , error, publisherId) => [{ type: 'User', id: "LIST"}],
    }),
  }),
  overrideExisting: false
})

export const {
  useGetPublisherUsersQuery,
} = publisherUserApiSlice
